import { lazy } from "react";
import Loadable from "app/components/Loadable";
import AuthGuard from "app/auth/AuthGuard";

const ChooseAccount = Loadable(lazy(() => import("./ChooseAccount")));
const ConfirmEmail = Loadable(lazy(() => import("./ConfirmEmail")));
const EmailRegistrationForm = Loadable(lazy(() => import("./EmailRegistrationForm")));
const EmailRegistrationFormFrame = Loadable(lazy(() => import("./EmailRegistrationFormFrame")));
const Loading = Loadable(lazy(() => import("./Loading")));
const LoggedOut = Loadable(lazy(() => import("./LoggedOut")));

const sessionRoutes = [
  {
    path: "/choose-account",
    element: (
      <AuthGuard>
        <ChooseAccount />
      </AuthGuard>
    ),
  },
  {
    path: "/confirm-email",
    element: (
      <AuthGuard>
        <ConfirmEmail />
      </AuthGuard>
    ),
  },
  {
    path: "/register",
    element: (
      <EmailRegistrationForm />
    ),
  },
  {
    path: "/register-frame",
    element: (
      <EmailRegistrationFormFrame />
    ),
  },
  {
    path: "/loading",
    element: (
      <Loading />
    ),
  },
  {
    path: "/logged-out",
    element: (
      <LoggedOut />
    ),
  },
];

export default sessionRoutes;
